import React from 'react'
import Connect from '../Component/Connect/Connect'
import Section from '../Component/Section/Section'
import Services from '../Component/Services/Services'

const Home = () => {
  return (
    <div>
      <Section/>
      <Services/>
      <Connect/>
    </div>
  )
}

export default Home